import React, { useState, useEffect, Fragment } from 'react'
// ** Icons Imports
import { Button, Modal, ModalHeader, ModalBody, Form, Label, FormFeedback, Spinner, Input, Col, Row, ModalFooter } from "reactstrap"
import { useNavigate, useParams } from "react-router-dom"
import '@styles/react/libs/react-select/_react-select.scss'
// ** Utils
import { isObjEmpty, selectThemeColors, isUserLoggedIn } from '@utils'
import { useForm, Controller } from 'react-hook-form'
import Select, { components } from 'react-select'
import classnames from 'classnames'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useDispatch, useSelector } from "react-redux"
import { createWorkorder, getClearStoreData, ValidateWorkorderCreation, GetSFRCompaniesByName, GetSFRCompanies, GetCompaniesByName } from '../../../../views/redux/store'
import ComponentSpinner from '../../../../components/spinner/Loading-spinner'
import { DefaultConfig } from '../../../../settings/config'
import CustomValueContainer from '../../../../views/Components/Select'

const msgStyles = {
    background: "#202a5b",
    color: "#ffffff",
    cursor: 'pointer'
}

const CreateWorkorder = ({ centerModal, closeModel, categoryId, typeId, valid }) => {
    const selectStyles = DefaultConfig().selectStyles
    const getUserRole = DefaultConfig().getUserRole
    const { woId } = useParams()
    const { catCode } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const stores = useSelector((state) => state.commonreducerSlice)
    const isEmployee = isUserLoggedIn && JSON.parse(isUserLoggedIn())?.isEmployee
    const [centeredModal, setCenteredModal] = useState(centerModal)
    const [woTypeValue, setwoTypeData] = useState(null)
    const [woComValue, setCompanyVal] = useState(null)
    const [woCatValue, setwoCatData] = useState(null)
    const [woTypeOptions, setwoTypeOptions] = useState([])
    const [zspinnerStatus, setzspinnerStatus] = useState(false)
    const [duplicateErrorAlert, setDuplicateErrorAlert] = useState(false)
    const [dupData, setDupData] = useState('')
    const [zloader, setzloader] = useState(false)
    const [companyData, setCompanyData] = useState([])
    const [salesforce, setSalesforce] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [addCompanyOption, setAddCompanyOption] = useState(false)

    useEffect(() => {
        if (stores.woBool) {
            setCenteredModal(stores.woBool)
        }
    }, [stores.woBool])

    useEffect(() => {
        if (stores.checkwoData) {
            if (isEmployee || !isEmployee) {
                setDupData(stores.checkwoData)
                if (stores.checkwoData.workorderValidationMessage) {
                    setDuplicateErrorAlert(true)
                } else {
                    setDuplicateErrorAlert(false)
                }
            }
        }
    }, [stores.checkwoData])

    useEffect(() => {
        if (woCatValue) {
            const woCates = stores.woCates.length > 0 ? stores.woCates : []
            if (woCates.find(find => find.value === woCatValue.value)) {
                let woTypes = woCates.find(find => find.value === woCatValue.value).woTypes.filter(item => getUserRole() || item.code !== 'AA')
                if (!isEmployee) {
                    if (woCatValue.code === 'FA') {
                        const customerRoles = JSON.parse(localStorage.getItem('userData'))?.customerRoles || []
                        if (customerRoles.length > 0) {
                            // Client Admin 
                            const findAdminRole = customerRoles.find(role => role?.roleId === 1)
                            if (findAdminRole) {
                                const exists = customerRoles.some(role => role?.roleId === 1 && role.typeId)
                                if (exists) {
                                    woTypes = woTypes.filter(wo => wo.isPublic === true && customerRoles.some(role => role.typeId === wo.value))
                                } else {
                                    woTypes = woTypes.filter(find => find.isPublic === true && (find.code === 'CAP' || find.code === 'SAP'))
                                }
                            }
                            // Client Staff
                            const findStaffRole = customerRoles.find(role => role?.roleId === 2)
                            if (findStaffRole) {
                                const exists = customerRoles.some(role => role?.roleId === 2 && role.typeId)
                                if (exists) {
                                    woTypes = woTypes.filter(wo => wo.isPublic === true && customerRoles.some(role => role.typeId === wo.value))
                                } else {
                                    woTypes = woTypes.filter(find => find.isPublic === true && (find.code === 'CAP' || find.code === 'SAP'))
                                }
                            }
                            // FIlling Agent Admin
                            const findAgentRole = customerRoles.find(role => role?.roleId === 3)
                            if (findAgentRole) {
                                const exists = customerRoles.some(role => role?.roleId === 3 && role.typeId)
                                if (exists) {
                                    woTypes = woTypes.filter(wo => wo.isPublic === true && customerRoles.some(role => role.typeId === wo.value))
                                } else {
                                    woTypes = woTypes.filter(find => find.isPublic === true)
                                }
                            }
                        } else {
                            woTypes = woTypes.filter(find => find.isPublic === true && find.code !== 'CAP' && find.code !== 'SAP')
                        }
                    } else {
                        woTypes = woTypes.filter(find => find.isPublic === true)
                    }
                    //  woTypes = woTypes.filter(find => find.isPublic === true)
                    // if (woCatValue.value === 2 && woCatValue.code === 'MT') {
                    //     const allCustomerCompanies = stores?.allCustomerCompanies
                    //     if (allCustomerCompanies?.length === 0) {
                    //         // woTypes = woTypes.filter(find => find.value === 9 && find.code === 'TCA')
                    //     }
                    // }
                }
                setwoTypeOptions(woTypes)
            }
        }
    }, [woCatValue])

    //  Get company Details from employee side search drop down
    useEffect(() => {
        if (salesforce.length > 2) {
            setIsLoading(true)
            const timer = setTimeout(() => {
                const searchOptions = async () => {
                    if (salesforce) {
                        if (woCatValue && woTypeValue) {
                            let responseData = ''
                            if (((woCatValue?.code === 'MT' && ((woTypeValue?.code === 'CA') || (woTypeValue?.code === 'MCA') || (woTypeValue?.code === 'LCC'))) || (woCatValue?.code === 'RTC' && ((woTypeValue?.code === 'LCC'))) || (woCatValue?.code === 'CG' && ((woTypeValue?.code === 'MCG'))))) {
                                responseData = await dispatch(GetSFRCompaniesByName({ salesforce }))
                            } else {
                                responseData = await dispatch(GetSFRCompaniesByName({ salesforce }))
                            }
                            if (responseData) {
                                const companyData = responseData.payload
                                if (companyData) {
                                    const sfCompanys = []
                                    let newCompanies = companyData
                                    if (woCatValue?.code === 'FA') {
                                        newCompanies = companyData.filter(item => /^\d+$/.test(item.agentId))
                                    } else if (woCatValue?.code === 'MT') {
                                        newCompanies = companyData.filter(item => item.agentId?.startsWith("MTTCA"))
                                    } else if (woCatValue?.code === 'RTC') {
                                        newCompanies = companyData.filter(item => item.agentId?.startsWith("RTC"))
                                    } else if (woCatValue?.code === 'MP') {
                                        newCompanies = companyData.filter(item => item.agentId?.startsWith("MP"))
                                    } else if (woCatValue?.code === 'MCA') {
                                        newCompanies = companyData.filter(item => item.agentId?.startsWith("MCA"))
                                    } else if (woCatValue?.code === 'CG') {
                                        newCompanies = companyData.filter(item => item.agentId?.startsWith("SFR"))
                                    }
                                    if (newCompanies.length > 0) {
                                        newCompanies.forEach((item) => {
                                            sfCompanys.push({ value: item.agentId, label: `${item.name}-${item.agentId}`, name: item.name, companyId: item.companyId })
                                        })

                                    } else {
                                        setAddCompanyOption(true)
                                    }
                                    setCompanyData(sfCompanys)
                                    setIsLoading(false)
                                }
                            }

                        }
                    }
                }
                if (salesforce) {
                    setIsLoading(true)
                    setAddCompanyOption(false)
                    searchOptions()
                } else {
                    setIsLoading(false)
                    // setCompanyData([])
                }
            }, 500)
            return () => clearTimeout(timer)
        } else {
            setIsLoading(false)
            // setCompanyData([])
            setAddCompanyOption(false)
        }
    }, [salesforce])


    // customer side by default get data based on cat and type select after loaded

    useEffect(() => {
        if (!centeredModal) {
            dispatch(getClearStoreData())
            setwoCatData(null)
            setDuplicateErrorAlert(false)
            setwoTypeData(null)
            setwoTypeOptions([])
            dispatch(createWorkorder(false))
            closeModel(centeredModal)
            setCompanyVal(null)
        }
    }, [centeredModal])

    const getValidationMessage = (categoryCode) => {
        switch (categoryCode) {
            case 'MT': return 'Training Center ID or Name is a required field'
            case 'RTC': return 'Training Center ID or Name is a required field'
            case 'MP': return 'Doctor ID or Name is a required field'
            case 'MCA': return 'Agent ID or Name is a required field'
            case 'FA': return 'Agent ID or Name is a required field'
            default: return 'Agent ID or Name is a required field'
        }
    }

    // ** Hooks
    const ValidSchema = yup.object().shape({
        [`wocateCompany`]: ((woCatValue?.code === 'FA' && ['AFF', 'RA', 'CSA', 'FAA', 'FCA', 'FDA', 'FVA', 'FUA', 'RA', 'MNC', 'CAP', 'SAP', 'AA'].includes(woTypeValue?.code)) || (woCatValue?.code === 'MT' && ['CA', 'MCA', 'LCC', 'MDA', 'TRE', "MRA", "TCR", "CAR", 'IA'].includes(woTypeValue?.code)) || (woCatValue?.code === 'RTC' && ['LCC'].includes(woTypeValue?.code)) || (woCatValue?.code === 'MP' && ["MCC", "PEC", "RPA"].includes(woTypeValue?.code)) || (woCatValue?.code === 'MP' && ["RC"].includes(woTypeValue?.code)) || (woCatValue?.code === 'MISC' && ["INV"].includes(woTypeValue?.code)) || (woCatValue?.code === 'MCA' && ["RC", "MB", "APR"].includes(woTypeValue?.code))) ? yup.object().nullable().required(getValidationMessage(woCatValue?.code)) : yup.object().nullable(),

        [`wotypeSelect`]: yup.object().nullable().required("Work Order Type is a required field"),
        [`wocateSelect`]: yup.object().nullable().required("Work Order Category is a required field")
    })

    const { trigger, handleSubmit, control, reset, formState: { errors }, setValue, clearErrors } = useForm({ mode: 'onChange', resolver: yupResolver(ValidSchema) })

    const handleReset = () => {
        reset({
            wotypeSelect: null,
            wocateSelect: null,
            wocateCompany: null
        })
        setCompanyVal(null)
        setwoCatData(null)
        setwoTypeData(null)
        // setwoTypeOptions([])
        setDuplicateErrorAlert(false)
    }

    useEffect(() => {
        const searchOptions = async () => {
            if (!isEmployee && woCatValue && woTypeValue && (woTypeValue.code === 'AFF' || woTypeValue.code === 'FAA' || woTypeValue.code === 'FUA' || woTypeValue.code === 'FVA' || woTypeValue.code === 'MNC' || woTypeValue.code === 'CAP' || woTypeValue.code === 'SAP' || woTypeValue.code === 'FCA' || (woCatValue?.code === 'CG' && (woTypeValue.code === 'MCG')) || (woCatValue?.code === 'MT' && (woTypeValue.code === 'CA' || woTypeValue.code === 'MCA' || woTypeValue.code === 'TRE' || woTypeValue.code === 'LCC' || woTypeValue.code === 'IA' || woTypeValue.code === "MRA" || woTypeValue.code === "MDA" || woTypeValue.code === "TCR" || woTypeValue.code === "CAR" || woTypeValue.code === "TCA")) || (woCatValue?.code === 'RTC' && (woTypeValue.code === 'CA' || woTypeValue.code === 'MCA' || woTypeValue.code === 'TRE' || woTypeValue.code === 'LCC' || woTypeValue.code === 'IA' || woTypeValue.code === "MRA" || woTypeValue.code === "MDA" || woTypeValue.code === "TCR" || woTypeValue.code === "CAR" || woTypeValue.code === "TCA")) || (woCatValue?.code === 'MP' && (woTypeValue.code === "RC" || woTypeValue.code === "PEC" || woTypeValue.code === "RPA")) || (woCatValue?.code === 'MCA' && (woTypeValue.code === "RC" || woTypeValue.code === "MB" || woTypeValue.code === "APR" || woTypeValue.code === "AA")))) {
                setIsLoading(true)
                const responseData = await dispatch(GetSFRCompanies({ ccode: woCatValue.code, tcode: woTypeValue.code }))
                const companyData = responseData.payload
                if (companyData) {
                    const sfCompanys = []
                    let newCompanies = companyData
                    if (woCatValue.code === 'FA') {
                        newCompanies = companyData.filter(item => /^\d+$/.test(item.agentId))
                    } else if (woCatValue.code === 'MT') {
                        newCompanies = companyData.filter(item => item.agentId?.startsWith("MTTCA"))
                    } else if (woCatValue.code === 'RTC') {
                        newCompanies = companyData.filter(item => item.agentId?.startsWith("RTC"))
                    } else if (woCatValue.code === 'MP') {
                        newCompanies = companyData.filter(item => item.agentId?.startsWith("MP"))
                    } else if (woCatValue.code === 'MCA') {
                        newCompanies = companyData.filter(item => item.agentId?.startsWith("MCA"))
                    } else if (woCatValue.code === 'CG') {
                        newCompanies = companyData.filter(item => item.agentId?.startsWith("SFR"))
                    } else if (woCatValue.code === 'RTC') {
                        newCompanies = companyData.filter(item => item.agentId?.startsWith("SFR"))
                    }
                    if (newCompanies.length > 0) {
                        newCompanies.forEach((item) => {
                            sfCompanys.push({ value: item.agentId, label: `${item.name}-${item.agentId}`, name: item.name, companyId: item.id })
                        })
                        if (newCompanies.length === 1) {
                            if (!isEmployee) {
                                if (woCatValue.code === "RTC" && woTypeValue.code === "TCA") {
                                    if (true) {
                                        setCompanyVal(null)
                                        setValue("wocateCompany", null)
                                        delete errors.wocateCompany
                                    }
                                } else {
                                    if (true) {
                                        setCompanyVal(sfCompanys[0])
                                        setValue("wocateCompany", sfCompanys[0])
                                        delete errors.wocateCompany
                                    }
                                }
                            }
                        }
                    } else {
                        setAddCompanyOption(true)
                        setIsLoading(false)
                    }
                    setCompanyData(sfCompanys)
                    setIsLoading(false)
                }
                setIsLoading(false)
            }
        }
        setAddCompanyOption(false)
        searchOptions()
    }, [woTypeValue])


    useEffect(() => {
        if (categoryId && typeId && valid) {
            if (isEmployee) {
                setwoCatData(categoryId)
                setwoTypeData(typeId)
                setValue('wocateSelect', categoryId)
                setValue('wotypeSelect', typeId)
            }
        }
    }, [categoryId, typeId, valid])

    function validationCall() {
        if (woTypeValue?.code === "TCA" && woComValue === null) {
            return true
        }
        return false
    }

    const onSubmit = async (values) => {
        localStorage.removeItem("companyData")
        sessionStorage.removeItem("companyData")
        localStorage.removeItem("applicationWoId")
        localStorage.removeItem("crewFin")
        let condition
        trigger()
        if (isObjEmpty(errors)) {
            dispatch(getClearStoreData())
            localStorage.removeItem('parseData')
            localStorage.removeItem('crewId')
            const dupDatas = ''
            // if (woCatValue.code === 'MT' && (woTypeValue.code === 'TCA' || woTypeValue.code === 'CA' || woTypeValue.code === 'LCC')) {
            if (
                ((woCatValue.code === 'RTC' && (woTypeValue.code === 'LCC' || validationCall())) ||
                    (woCatValue.code === 'MT' && (woTypeValue.code === 'LCC' || validationCall())) ||
                    (woCatValue.code === 'CG' && woTypeValue.code === 'MCG')) ||
                (woCatValue?.code === 'MCA' && ["CAS"].includes(woTypeValue?.code)) ||
                (woCatValue?.code === 'MCR' && ["CAS", "MCC"].includes(woTypeValue?.code))
            ) {
                setCenteredModal(!centerModal)
                localStorage.setItem("companyData", JSON.stringify(woComValue))
                sessionStorage.setItem("companyData", JSON.stringify(woComValue))
                navigate('/pageRefresh')
                setTimeout(() => {
                    navigate(`/${woCatValue.code}/${woTypeValue.code}/save`)
                }, 500)
            } else {
                if (!dupDatas) {
                    setzspinnerStatus(true)
                    if ((woCatValue?.code === 'FA' && ['FAA', 'FCA', 'AFF', 'FUA', 'FDA', 'FVA', 'MC', 'CAP', 'SAP', 'AA'].includes(woTypeValue?.code)) || (woCatValue?.code === 'MT' && ['CA', 'MDA', "TRE", "MRA", "TCR", "CAR", 'IA', "TCA"].includes(woTypeValue?.code))
                        || (woCatValue?.code === 'MP' && ["RC", "PEC", "RPA"].includes(woTypeValue?.code)) || (woCatValue?.code === 'MCA' && ["RC", "MB", "APR"].includes(woTypeValue?.code)) || (woCatValue?.code === 'RTC' && ["TCA", "LCC"].includes(woTypeValue?.code)) || (woCatValue?.code === 'MISC' && ["INV"].includes(woTypeValue?.code))) {
                        if (woComValue) {
                            localStorage.setItem("companyData", JSON.stringify(woComValue))
                            sessionStorage.setItem("companyData", JSON.stringify(woComValue))
                        } else {
                            localStorage.removeItem("companyData")
                        }

                    } else {
                        localStorage.removeItem("companyData")
                    }
                    const wocateSelect = values.wocateSelect
                    const wotypeSelect = values.wotypeSelect
                    const obj = {
                        type: woTypeValue ? woTypeValue.code : null,
                        categoryId: woCatValue ? woCatValue.code : null
                    }
                    if ((woCatValue?.code === 'FA' && ['RA', 'CSA', 'FCA', 'AFF', 'FAA', 'FCA', 'MC', 'CAP', "SAP", 'AA'].includes(woTypeValue?.code)) || (woCatValue?.code === 'MT' && ['MCA', 'CA', "MDA", "TRE", "MRA", "TCR", "CAR", 'IA', "TCA"].includes(woTypeValue?.code)) || (woCatValue?.code === 'MP' && ["RC", "PEC", "RPA"].includes(woTypeValue?.code)) || (woCatValue?.code === 'MCA' && ["RC", "MB", "APR"].includes(woTypeValue?.code)) || (woCatValue?.code === 'RTC' && ["TCA", "LCC"].includes(woTypeValue?.code)) || (woCatValue?.code === 'MISC' && ["INV"].includes(woTypeValue?.code))) {
                        obj['companyId'] = woComValue?.companyId ? woComValue?.companyId : ''
                    } else if (woTypeValue.code === 'FUA' || woTypeValue.code === 'FVA' || woTypeValue.code === 'FDA') {
                        obj['companyId'] = woComValue?.value ? woComValue?.value : ''
                    }
                    // if (woCatValue?.code === 'MCR' && ["CAS"].includes((woTypeValue?.code))) {
                    //     setTimeout(() => {
                    //         {
                    //             navigate(`/${wocateSelect.code}/${wotypeSelect.code}/save`)
                    //         }
                    //     }, 2000)
                    //     return
                    // }
                    let responseData
                    if (true) {
                        responseData = await dispatch(ValidateWorkorderCreation(obj))
                        if (responseData.payload) {
                            const data = responseData.payload.data
                            if (data && data.workorderValidationMessage === undefined) {
                                condition = true
                                if (woId || catCode) {
                                    setzloader(false)
                                    navigate('/pageRefresh')
                                    setTimeout(() => {
                                        if (data.woId && data.woId > 0) {
                                            navigate(`/${wocateSelect.code}/${wotypeSelect.code}/${data.woId}`)
                                        } else {
                                            navigate(`/${wocateSelect.code}/${wotypeSelect.code}/save`)
                                        }
                                    }, 2000)
                                } else {
                                    setzloader(false)
                                    if (data.woId && data.woId > 0) {
                                        navigate(`/${wocateSelect.code}/${wotypeSelect.code}/${data.woId}`)
                                    } else {
                                        navigate(`/${wocateSelect.code}/${wotypeSelect.code}/save`)
                                    }
                                }
                            } else if (data?.workorderValidationMessage) {
                                setzspinnerStatus(false)
                                setzloader(false)
                                setDupData(data)
                                setDuplicateErrorAlert(true)
                            } else {
                                setzspinnerStatus(false)
                                setzloader(false)
                            }
                        }
                    }
                    setzloader(false)

                    // }
                    if (condition === true) {
                        setDuplicateErrorAlert(false)
                        setDupData('')
                        setCenteredModal(!centerModal)
                    }
                }
            }

        }
    }

    const NoOptionsMessage = (props) => {
        return (
            <components.NoOptionsMessage {...props}>
                {addCompanyOption ? (
                    <Fragment>
                        <div>No Options</div>
                    </Fragment>
                ) : (
                    <Fragment>
                        {isEmployee ? (
                            <div>Enter min 3 numbers or 3 characters.</div>
                        ) : (
                            <div>No options.</div>
                        )}
                    </Fragment>
                )}
            </components.NoOptionsMessage>
        )
    }

    const handleInputChange = (inputValue, action) => {
        // const trimmedValue = inputValue.replace(/\s+/g, '')
        const trimmedValue = inputValue.trimStart()
        if (action.action !== "input-blur" && action.action !== "menu-close") {
            setSalesforce(trimmedValue)
        }
    }

    const placeholderMethod = () => {
        if (isEmployee) {

            if (woTypeValue?.code !== "TCA") {
                return `Search by Agent ID or Name  <span class='text-danger'>*</span>`
            } else {
                return `Search by Agent ID or Name`
            }

        } else {
            if (woTypeValue?.code !== "TCA") {
                return `Select Agent <span class='text-danger'>*</span>`
            } else {
                return `Select Agent`
            }
        }
    }

    function getPlaceholder(cat, woTypeValue) {

        const arrayNames = [
            { category: "MT", placeholder: "Select Training Center" },
            { category: "MP", placeholder: "Select Doctor" },
            { category: "MCA", placeholder: "Select Agent" },
            { category: "FA", placeholder: "Select Agent" },
            { category: "RTC", placeholder: "Select Training Center" }
        ]

        const basePlaceholder = arrayNames.find(item => item.category === cat)?.placeholder || "Select Agent"

        if (isEmployee) {
            if (woTypeValue !== "TCA") {
                return `${basePlaceholder} <span class='text-danger'>*</span>`
            } else {
                return basePlaceholder
            }
        } else {
            if (woTypeValue !== "TCA") {
                return `${basePlaceholder} <span class='text-danger'>*</span>`
            } else {
                return basePlaceholder
            }
        }
    }

    return (
        <div className='vertically-centered-modal'>
            <Modal isOpen={centeredModal} toggle={() => setCenteredModal(!centeredModal)} color='primary' className='modal-dialog-centered'>
                <Fragment>
                    <ModalHeader toggle={() => setCenteredModal(!centeredModal)}>Create Work Order</ModalHeader>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        {!zloader ? (
                            <Fragment>
                                <ModalBody className='p-2'>
                                    <Row>
                                        <Col sm='12' md='12' lg='12' xl='12'>
                                            <div className='select_create my-2'>
                                                <Controller
                                                    render={({ field: { onChange, ref } }) => (
                                                        <Select
                                                            inputRef={ref}
                                                            classNamePrefix="select"
                                                            options={stores ? (stores.woCates.length > 0 ? stores.woCates : []) : []}
                                                            value={woCatValue}
                                                            onChange={(val) => {
                                                                if (val) {
                                                                    if ((val?.value !== woCatValue?.value) && woCatValue) {
                                                                        setwoTypeOptions([])
                                                                    }
                                                                }
                                                                if (val && (val?.value === woCatValue?.value)) {

                                                                } else {
                                                                    clearErrors('wocateCompany')
                                                                    onChange(val, setwoCatData(val), setwoTypeData(null), setSalesforce(''), setwoTypeOptions([]), setCompanyVal(null), setCompanyData([]), setValue('wotypeSelect', null), setValue('wocateCompany', null), setDuplicateErrorAlert(false))
                                                                }
                                                            }
                                                            }
                                                            className={classnames('react-select', { 'is-invalid': errors['wocateSelect'] })}
                                                            isClearable
                                                            // isOptionDisabled={(option) => option.disabled}
                                                            placeholder={`Select Work Order Category <span class='text-danger'>*</span>`}
                                                            styles={selectStyles}
                                                            components={{ ValueContainer: CustomValueContainer }}
                                                        // isDisabled={true}
                                                        />
                                                    )}
                                                    defaultValue={woCatValue ? woCatValue : null}
                                                    control={control}
                                                    name='wocateSelect'
                                                    theme={selectThemeColors}
                                                />
                                                {errors.wocateSelect && <FormFeedback>{errors.wocateSelect.message}</FormFeedback>}
                                            </div>
                                        </Col>
                                        <Col sm='12' md='12' lg='12' xl='12'>
                                            <div className='select_create my-2'>
                                                <Controller
                                                    render={({ field: { onChange, ref } }) => (
                                                        <Select
                                                            inputRef={ref}
                                                            classNamePrefix="select"
                                                            options={woTypeOptions}
                                                            value={woTypeValue}
                                                            onChange={val => { onChange(val, setwoTypeData(val), setSalesforce(''), setCompanyVal(null), setCompanyData([]), setValue('wocateCompany', null), setDuplicateErrorAlert(false)) }}
                                                            className={classnames('react-select', { 'is-invalid': errors['wotypeSelect'] })}
                                                            isClearable
                                                            isOptionDisabled={(option) => option.disabled}
                                                            placeholder={`Select Work Order Type <span class='text-danger'>*</span>`}
                                                            styles={selectStyles}
                                                            components={{ ValueContainer: CustomValueContainer }}
                                                        />
                                                    )}
                                                    defaultValue={woTypeValue}
                                                    control={control}
                                                    name='wotypeSelect'
                                                    theme={selectThemeColors}
                                                />
                                                {errors.wotypeSelect && <FormFeedback>{errors.wotypeSelect.message}</FormFeedback>}
                                                {/* {!isEmployee &&
                                                        <Fragment>
                                                            {(duplicateErrorAlert && dupData) && <div className="invalid-feedback-error" dangerouslySetInnerHTML={{ __html: dupData.workorderValidationMessage }}></div>}
                                                        </Fragment>
                                                    } */}
                                            </div>
                                        </Col>
                                        {(woTypeValue && ((woCatValue?.code === 'FA' && ['AFF', 'RA', 'CSA', 'FAA', 'FCA', 'FVA', 'FUA', 'FDA', 'RA', 'MC', 'CAP', "SAP", 'AA'].includes(woTypeValue?.code)) ||
                                            //  (woCatValue?.code === 'CG' && ['MCG'].includes(woTypeValue?.code)) ||
                                            (woCatValue?.code === 'MT' && ['CA', 'MCA', 'CCG', "MDA", "TRE", "MRA", "TCR", "CAR", 'IA', 'LCC', "TCA"].includes(woTypeValue?.code)) || (woCatValue?.code === 'MP' && ['RC', "PEC", "RPA"].includes(woTypeValue?.code)) || (woCatValue?.code === 'MCA' && ['RC', "MB", "APR"].includes(woTypeValue?.code)) || (woCatValue?.code === 'MP' && ['MCC'].includes(woTypeValue?.code)) || (woCatValue?.code === 'RTC' && ['LCC'].includes(woTypeValue?.code)) || (woCatValue?.code === 'MISC' && ['INV'].includes(woTypeValue?.code)) || (woCatValue?.code === 'RTC' && ['TCA'].includes(woTypeValue?.code) && isEmployee))) &&
                                            <Col sm='12' md='12' lg='12' xl='12'>
                                                <div className='select_create my-2'>
                                                    {isEmployee ? <Controller
                                                        render={({ field: { onChange, ref } }) => (
                                                            <Select
                                                                inputValue={salesforce}
                                                                inputRef={ref}
                                                                classNamePrefix="select"
                                                                options={companyData}
                                                                value={woComValue}
                                                                onChange={val => { onChange(val, setCompanyVal(val), setDuplicateErrorAlert(false)) }}
                                                                className={classnames('react-select', { 'is-invalid': errors['wocateCompany'] })}
                                                                isClearable
                                                                components={{ NoOptionsMessage, ValueContainer: CustomValueContainer }}
                                                                styles={((addCompanyOption) && { noOptionsMessage: base => ({ ...base, ...msgStyles }) }, selectStyles)}
                                                                onInputChange={handleInputChange}
                                                                isLoading={isLoading}
                                                                loadingMessage={() => 'Loading...'}
                                                                // isDisabled={!woTypeValue}
                                                                //s placeholder={` <span class='text-danger'>*</span>`}
                                                                placeholder={getPlaceholder(woCatValue?.code, woTypeValue?.code)}
                                                            />

                                                        )}
                                                        defaultValue={woComValue}
                                                        control={control}
                                                        name='wocateCompany'
                                                        theme={selectThemeColors}
                                                    /> : <Controller
                                                        render={({ field: { onChange, ref } }) => (
                                                            <Select
                                                                inputRef={ref}
                                                                classNamePrefix="select"
                                                                options={companyData}
                                                                value={woComValue}
                                                                onChange={val => { onChange(val, setCompanyVal(val), setDuplicateErrorAlert(false)) }}
                                                                className={classnames('react-select', { 'is-invalid': errors['wocateCompany'] })}
                                                                isClearable
                                                                components={{ NoOptionsMessage, ValueContainer: CustomValueContainer }}
                                                                styles={selectStyles}
                                                                // onInputChange={handleInputChange}
                                                                isLoading={isLoading}
                                                                loadingMessage={() => 'Loading...'}
                                                                // isDisabled={!woTypeValue}
                                                                // placeholder={`Select Agent ${woTypeValue?.code !== "TCA" ? <span class='text-danger'>*</span> : ""}`}
                                                                placeholder={getPlaceholder(woCatValue?.code, woTypeValue?.code)}
                                                            />
                                                        )}
                                                        defaultValue={woComValue}
                                                        control={control}
                                                        name='wocateCompany'
                                                        theme={selectThemeColors}
                                                    />
                                                    }
                                                    {errors.wocateCompany && <FormFeedback>{errors.wocateCompany.message}</FormFeedback>}
                                                </div>
                                            </Col>
                                        }
                                        {(duplicateErrorAlert && dupData) && <div className="invalid-feedback-error" dangerouslySetInnerHTML={{ __html: dupData.workorderValidationMessage }}></div>}

                                    </Row>
                                </ModalBody>
                                <ModalFooter className='p-0 d-block' style={{ border: 0, marginTop: '30px' }}>
                                    <Row>
                                        <Col sm='12' md='12' lg='12' xl='12' className='p-0'>
                                            <div className='model_popup_panel model_popup_submit_btn' style={{ justifyContent: 'center' }}>
                                                {zspinnerStatus === true ? (
                                                    <Button.Ripple color='primary' disabled={zspinnerStatus}>
                                                        <Spinner size='sm' />
                                                        <span className='mx-50'>Loading...</span>
                                                    </Button.Ripple>
                                                ) : (
                                                    <Fragment>
                                                        <Button className='me-1 reset_button_view' outline color='secondary' type='reset' onClick={handleReset}>
                                                            Reset
                                                        </Button>
                                                        <Button className='create_submit_btn' type='submit' disabled={duplicateErrorAlert}>
                                                            Submit
                                                        </Button>
                                                    </Fragment>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                </ModalFooter>
                            </Fragment>
                        ) : (
                            <ComponentSpinner />
                        )}
                    </Form>
                </Fragment>

            </Modal>
        </div>
    )
}
export default CreateWorkorder